import { OverlayModule } from '@angular/cdk/overlay';
import { Component, computed, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';

import { UserProfileComponent } from '../user-profile/user-profile.component';

const hasSeenGuideKey = 'hasSeenGuide';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [
    MatToolbarModule,
    MatDividerModule,
    UserProfileComponent,
    RouterLink,
    MatButtonModule,
    MatTooltip,
    OverlayModule,
    MatCardModule,
  ],
})
export class HeaderComponent implements OnInit {
  private router = inject(Router);
  isOpen = false;

  showHelpButton = computed(() => {
    return !this.router.url.includes('guides');
  });

  ngOnInit(): void {
    const hasSeenGuide = localStorage.getItem(hasSeenGuideKey);

    if (!hasSeenGuide) {
      this.isOpen = true;
    }
  }
}
